import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../../../../redux/store';
import Select, { Option } from '../../../../../../components/common/Select';
import { CarRelatedWithContract } from '../../../../../../types/car';
import styles from './styles.module.css';
import ModalFooter from '../ModalFooter';
import {
  removeEditTask,
  setEditTask,
} from '../../../../../../redux/carAllocationEditSlice';
import Label from '../../../../../../components/common/Label';
import EmptySelectModal from '../EmptySelectModal';
import { useGetCarsRelatedWithContractQuery } from '../../../../../../api/contractApi';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { format } from 'date-fns';

const getDate = (datetimeString: string) =>
  format(new Date(datetimeString), 'yyyy-MM-dd');
const getCarLabel = (car: CarRelatedWithContract) =>
  `${car.carCategory.name} / ${car.carNo}`;
const SelectCar: FC = () => {
  const editState = useSelector(
    (state: AppState) => state.carAllocationEdit.editState
  );
  const { data: cars, isSuccess } = useGetCarsRelatedWithContractQuery(
    editState?.primary.contractId &&
      editState.targetUserId &&
      editState.primary.startDate
      ? {
          contractId: editState.primary.contractId,
          userId: editState.targetUserId,
          date: getDate(editState.primary.startDate),
        }
      : skipToken
  );
  const [selected, onSelect] = useState<CarRelatedWithContract | null>(null);
  useEffect(() => {
    // 念のため cars がキャッシュヒットしなかった場合にも選択状態を反映させるため Effect を使用する
    onSelect(
      cars?.cars.find((c) => c.carId === editState?.primary.carId) ??
        cars?.cars[0] ??
        null
    );
  }, [cars]);
  const options: Option[] = (cars?.cars || []).map((car) => {
    return {
      label: getCarLabel(car),
      value: `${car.carId}`,
    };
  });
  const onSelectCar = (value: string) => {
    const car = cars?.cars.find((car) => car.carId === Number(value)) || null;
    onSelect(car);
  };
  const dispatch = useDispatch<AppDispatch>();
  const onBack = () => {
    if (!editState) {
      return;
    }

    if (editState.isMoving) {
      dispatch(removeEditTask());
      return;
    }

    dispatch(setEditTask({ ...editState, step: 1 }));
  };
  const onNext = () => {
    if (!editState) {
      return;
    }

    dispatch(
      setEditTask({
        ...editState,
        primary: {
          ...editState.primary,
          carId: selected?.carId,
        },
        secondary: {
          ...editState.secondary,
          carId: selected?.carId,
        },
        selectedCarName: selected ? getCarLabel(selected) : '',
        step: 3,
      })
    );
  };

  return (
    <div className={styles.scrollContainer}>
      <div className={styles.content}>
        <Head />
        <Label
          inputs={
            <Select
              placeholder="車両を選択..."
              options={options}
              value={`${selected?.carId || ''}`}
              onChange={(e) => {
                onSelectCar(e.target.value);
              }}
            />
          }
        >
          車両
        </Label>
      </div>
      {isSuccess && !cars?.total && (
        <EmptySelectModal
          requestClose={() => {
            dispatch(removeEditTask());
          }}
          type="車両"
        />
      )}
      <ModalFooter
        onNext={onNext}
        onBack={editState?.isMoving === false ? undefined : onBack}
        disabledOnNext={!selected}
      ></ModalFooter>
    </div>
  );
};

const Head: FC = () => {
  return (
    <div className={styles.headContainer}>
      <div className={styles.title}>使用する車両を選択してください</div>
      <div className={styles.sub}>
        ※案件登録時の条件に合う車両のみ選択できます
      </div>
    </div>
  );
};

export default SelectCar;
